export const useMenu = () => ([
  {
    "label": "Home",
    "link": "/",
    "page": "home"
  },
  {
    "label": "Agendă",
    "link": "/agenda",
    "page": "agenda"
  },
  {
    "label": "Workshopuri",
    "link": "/workshopuri",
    "page": "workshops"
  },
  {
    "label": "Speakeri & Traineri",
    "link": "/speakeri-traineri",
    "page": "speakers-and-trainers"
  },
  {
    "label": "Parteneri",
    "link": "/parteneri",
    "page": "partners"
  },
  {
    "label": "Despre Noi",
    "link": "/despre-noi",
    "page": "about-us"
  },
  {
    "label": "Bilete",
    "link": "/bilete",
    "page": "tickets"
  }
]);